define('fukit/view/block/content.header.view',['require','exports','module','uikit/uikit','./segment.container.view','underscore','../../behavior/resolve.options.behavior'],function(require, exports, module) {
  //prettier-ignore
  var UIKit                  = require('uikit/uikit'),
      SegmentContainerView   = require('./segment.container.view'),
      _                      = require('underscore'),
      ResolveOptionsBehavior = require('../../behavior/resolve.options.behavior');

  var ContentHeaderView = SegmentContainerView.extend({

    options: _.extend({}, SegmentContainerView.prototype.options, {
      headerText: '',
      attached: false,
      color: 'blue',
      padded: false
    }),

    behaviors: {
      ResolveOptionsBehavior: {
        behaviorClass: ResolveOptionsBehavior
      }
    },

    components: [
      {
        name: 'header',
        type: UIKit.Header,
        tagName: 'h4'
      }
    ],

    updateAttributes: function() {
      var attached = this.getOption('attached');
      this.addClass((_.isString(attached) ? attached + ' ' : '') + 'attached', this.getBoolOption('attached'));
      this.addClass(this.getOption('color'), this.getBoolOption('color')),
      this.addClass('padded', this.getBoolOption('padded'))
    }

  });

  module.exports = ContentHeaderView;
});

